import { useTranslation } from 'react-i18next';
import { useSelectedFilterItems } from '@/features/connect-dots/hooks/useSelectedFilterItems';

export const FilterResetButton = () => {
  const { t } = useTranslation();
  const { clearNodes } = useSelectedFilterItems();

  const handleClick = () => {
    clearNodes();
  };

  return (
    <button
      className="w-full rounded-tr-xl border border-rw-light-gray bg-white px-4 py-1 text-red-600 hover:opacity-80"
      onClick={handleClick}
    >
      {t('リセット')}
    </button>
  );
};
